import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up

@Component({
  selector: 'app-protocolsearch',
  templateUrl: './protocolsearch.component.html',
  styleUrls: ['./protocolsearch.component.css']
})
export class ProtocolsearchComponent implements OnInit {
  prHdCode ='';
  prHdName ='';
  prHdCycle =0;
  prHdDays =0;
  prHdNotes ='';
  compCode ='1';
  userID ='sa';
  modifiedDate ='2022-01-01';

  protocolHD: ProtocolHDModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public protocolHDService: ProtocolHDService,
              public protocol: ProtocolHDModel,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<ProtocolsearchComponent>,
              @Inject(MAT_DIALOG_DATA)
              public protocolHDSelectedData: ProtocolHDModel) { }

  ngOnInit(): void {this.retriveProtocolTop();
  }
  retriveProtocolTop() {
    this.protocolHDService.getProtocolHDLookupToop(this.compCode).subscribe((data: ProtocolHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.protocolHD[i] = data[i];
      }

    })
  }
  retriveProtocol() {
    this.protocolHD = [];
    this.protocolHDService.getProtocolHDLookup(this.prHdCode, this.prHdName).subscribe((data: ProtocolHDModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.protocolHD[i] = data[i];
    }

  })
}
  SelectProtocol(pro: ProtocolHDModel){
    this.protocolHDSelectedData.prHdCode = pro.prHdCode
    this.protocolHDSelectedData.prHdName = pro.prHdName
    this.protocolHDSelectedData.prHdCycle= pro.prHdCycle
    this.protocolHDSelectedData.prHdDays= pro.prHdDays
    this.protocolHDSelectedData.prHdNotes= pro.prHdNotes

    this.protocolHDSelectedData.userID = pro.userID
    this.protocolHDSelectedData.modifiedDate = pro.modifiedDate
    this.protocolHDSelectedData.compCode = pro.compCode
    this.submitClicked.emit(this.protocolHDSelectedData);
    this.dialogRef.close();
 
  }


}
